<app-toolbar-cammel></app-toolbar-cammel>
<div class="container">
    <div class="mat-elevation-z4 table-container">
        <table class="w-100 mat-table" mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="identificationNumber">
                <th mat-header-cell *matHeaderCellDef>Número Identificación</th>
                <td mat-cell *matCellDef="let element">{{element.identificationNumber}}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">
                    <mat-chip [ngClass]="getChipClass(element.status)" selected>{{element.status}}</mat-chip>
                </td>
            </ng-container>

            <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef>Información</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-stroked-button class="files-btn" (click)="openFileDialog(element)"
                        [disabled]="element.code === 12">Ver Información</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                    <div class="buttons">
                        <button mat-flat-button color="primary" (click)="openDialog('Aprobar', true, element.id)"
                            [disabled]="disableApproveButton(element)">
                            Aprobar
                        </button>
                        <button mat-flat-button color="warn" (click)="openDialog('Rechazar', false, element.id)"
                            [disabled]="disableRejectButton(element)">
                            Rechazar
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator class="mat-paginator-border mat-paginator" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
        </mat-paginator>
    </div>
</div>